import axios from './axios';

const CommitteeService = {
  getMembers: () => axios.get('/api/v1/committee-members'),
  getMember: (id) => axios.get(`/api/v1/committee-members/${id}`),
  createMember: (data) => axios.post('/api/v1/committee-members', data),
  updateMember: (id, data) => axios.put(`/api/v1/committee-members/${id}`, data),
  deleteMember: (id) => axios.delete(`/api/v1/committee-members/${id}`),
  getCategories: () => axios.get('/api/v1/committee-key-responsibilities'),
  createCategory: (data) => axios.post('/api/v1/committee-key-responsibilities', data),
  updateCategory: (id, data) => axios.put(`/api/v1/committee-key-responsibilities/${id}`, data),
  deleteCategory: (id) => axios.delete(`/api/v1/committee-key-responsibilities/${id}`),
};

export default CommitteeService;
